var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenu = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "menu_svg__a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#menu_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 18v-2h18v2H3Zm0-5v-2h18v2H3Zm0-5V6h18v2H3Z"
}))));
SvgMenu.viewBox = '0 0 24 24';
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenu);
export default ForwardRef;